import React from 'react';
import { Select, ConfigProvider } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { SearchFiltersProps } from './types';
import { FiltersContainer, StyledSearchInput, StyledSelectFilter } from './styles';
import { PLACEHOLDERS } from './constants';
import { useTheme } from '../../context/ThemeContext';
import { getAntdThemeConfig } from '../../utils/antdTheme';

export const SearchFilters: React.FC<SearchFiltersProps> = ({
  searchQuery,
  selectedType,
  deviceTypes,
  onSearchChange,
  onTypeFilterChange,
}) => {
  const { isDarkMode } = useTheme();

  return (
    <ConfigProvider theme={getAntdThemeConfig(isDarkMode)}>
      <FiltersContainer>
        <StyledSearchInput
          {...({ $isDark: isDarkMode } as any)}
          placeholder={PLACEHOLDERS.SEARCH}
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          prefix={<FontAwesomeIcon icon={faSearch} />}
          allowClear
        />
        <StyledSelectFilter
          {...({ $isDark: isDarkMode } as any)}
          placeholder={PLACEHOLDERS.FILTER_TYPE}
          value={selectedType || undefined}
          onChange={onTypeFilterChange}
          allowClear
        >
          {deviceTypes.map((type) => (
            <Select.Option key={type.id} value={type.id}>
              {type.name}
            </Select.Option>
          ))}
        </StyledSelectFilter>
      </FiltersContainer>
    </ConfigProvider>
  );
};
